import React, { useState } from 'react';
import ReactFullpage from "@fullpage/react-fullpage";
import {
    Wrapper
} from "./styles";
import Header from '../../Shared/Header';
import Banner from '../../Views/Index/Banner';

const Index = () => {
    const [activeSection, setActiveSection] = useState("banner");
    const [headerColor, setHeaderColor] = useState("transparent"); //transparent - white

    return (
        <Wrapper>
            <Header
                activeSection={activeSection}
                headerColor={headerColor}
            />
            <ReactFullpage
                //fullpage options
                anchors={[
                    "banner",
                ]}
                licenseKey="sepah_landing"
                scrollingSpeed={1000}
                navigation={false}
                onLeave={(origin, destination, direction) => {
                    setActiveSection(destination.anchor)
                    if (destination.index !== 0) {
                        setHeaderColor("white")
                    } else {
                        setHeaderColor("transparent")
                    }
                }}
                render={({ state, fullpageApi }) => {
                    return (
                        <ReactFullpage.Wrapper>
                            <div className="section">
                                <Banner />
                            </div>
                        </ReactFullpage.Wrapper>
                    );
                }}
            />
        </Wrapper>
    )
}

export default Index;